import React, { useContext } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';

import {
  useHistory,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import { avatarImage } from '../../utils/constants';

import { menuDrawerAvatar, menuDrawerList } from '../../styles/componentsStyles';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function MenuDrawer({ showDrawer, handleGotoScreen, handleShowDrawer, type }) {
  const sessionContext = useContext(SessionContext);
  const user = sessionContext.role;
  // PROVES
  // const user = 'Admin';

  const history = useHistory();

  const avatarStyle = menuDrawerAvatar();
  const listStyle = menuDrawerList();

  const logout = () => {
    // Borram la info de la sessió emmagatzemanda a l'storage del navegador
    sessionStorage.removeItem('sessionInfo');
    // Desactivam mostrar el recordatori, es torna a activar en fer login
    sessionContext.rememberTokenIsNearlyToExpire = false;
    // Tornam a l'arrel, login
    history.push('/');
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    handleShowDrawer(open);
  };

  const list = () => (
    <div
      role='presentation'
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List className={listStyle.root} disablePadding>
        {/* ------------------------ PROGRAMES ------------------------ */}
        {((user === 'Admin' || user === 'Clinician') && (
          <React.Fragment>
            <ListItem className={listStyle.white}>
              <ListItemText primary={translations['_programs']} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItem>
            <ListItem className={listStyle.white}>
              <List className={listStyle.nested} disablePadding>
                <ListItem button>
                  <ListItemText
                    primary={translations['_consult']}
                    onClick={() => handleGotoScreen('listPrograms')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
                {(user === 'Admin') && (
                <ListItem button className={listStyle.nested}>
                  <ListItemText
                    primary={translations['_new']}
                    onClick={() => handleGotoScreen('newProgramInfo')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
                )}
              </List>
            </ListItem>
          </React.Fragment>
        ))}
        {/* ------------------------ CLÍNICS ------------------------ */}
        {((user === 'Admin' || user === 'Clinician') && (
          <React.Fragment>
            <ListItem className={listStyle.white}>
              <ListItemText primary={translations['_clinicians']} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItem>
            <ListItem className={listStyle.white}>
              <List className={listStyle.nested} disablePadding>
                <ListItem button>
                  <ListItemText
                    primary={translations['_consult']}
                    onClick={() => handleGotoScreen('listClinicians')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
                {(user === 'Admin') && (
                <ListItem button className={listStyle.nested}>
                  <ListItemText
                    primary={translations['_new']}
                    onClick={() => handleGotoScreen('newClinicianInfo')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
                )}
              </List>
            </ListItem>
          </React.Fragment>
        ))}
        {/* ------------------------ PACIENTS ------------------------ */}
        {(user === 'Patient' && (
          <React.Fragment>
            <ListItem className={listStyle.white}>
              <ListItemText primary={translations['_patient']} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItem>
            <ListItem className={listStyle.white}>
              <List className={listStyle.nested} disablePadding>
                <ListItem button>
                  <ListItemText
                    primary={translations['_forms']}
                    onClick={() => handleGotoScreen('listPatientForms')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
              </List>
            </ListItem>
          </React.Fragment>
        )) || (
          <React.Fragment>
            <ListItem className={listStyle.white}>
              <ListItemText primary={translations['_patients']} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItem>
            <ListItem className={listStyle.white}>
              <List className={listStyle.nested} disablePadding>
                <ListItem button>
                  <ListItemText
                    primary={translations['_consult']}
                    onClick={() => handleGotoScreen('listPatients')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
                {(user === 'Admin') && (
                  <ListItem button className={listStyle.nested}>
                    <ListItemText
                      primary={translations['_new']}
                      onClick={() => handleGotoScreen('newPatientInfo')}
                      primaryTypographyProps={{ variant: 'h6' }}
                    />
                  </ListItem>
                )}
              </List>
            </ListItem>
          </React.Fragment>
        )}
        {/* ------------------------ ELS MEUS FORMULARIS ------------------------ */}
        {(user === 'Clinician' && (
          <React.Fragment>
            <ListItem className={listStyle.white}>
              <ListItemText primary={translations['_forms']} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItem>
            <ListItem className={listStyle.white}>
              <List className={listStyle.nested} disablePadding>
                <ListItem button>
                  <ListItemText
                    primary={translations['_myForms']}
                    onClick={() => handleGotoScreen(`mySchedulesInfoClinician/${sessionContext.userId}`)} // 'mySchedulesInfoClinician')}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
              </List>
            </ListItem>
          </React.Fragment>
        ))}
        {/* ------------------------ LOGOUT  ------------------------ */}
        <ListItem
          button
          className={listStyle.nested}
          onClick={logout}
        >
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText
            primary={translations['_logout']}
            primaryTypographyProps={{ variant: 'h6' }}
          />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div>
      <React.Fragment>
        <Drawer anchor='left' open={showDrawer} onClose={toggleDrawer(false)}>
          <div className={avatarStyle.root}>
            <div className={avatarStyle.container}>
              <img src={avatarImage[type]} alt='Generic Avatar' className={avatarStyle.image} />
            </div>
            <Typography variant='h6' align='center'>{sessionContext.username}</Typography>
            {list()}
          </div>
        </Drawer>
      </React.Fragment>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
MenuDrawer.propTypes = {
  handleGotoScreen: PropTypes.func.isRequired,
  handleShowDrawer: PropTypes.func.isRequired,
  showDrawer: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
};
